import { useEffect, useState } from 'react';
import { getMode, setMode, nextMode } from '../utils/theme';

export const THEME_LABELS = { light: 'Light', dark: 'Dark', system: 'Match device' };
export const THEME_ICONS = { light: 'fa-sun', dark: 'fa-moon', system: 'fa-circle-half-stroke' };

// Current theme choice plus a function that steps to the next one. Stays in
// step when another toggle (desktop bar / phone sheet) changes it.
export default function useThemeMode() {
  const [mode, setLocal] = useState(getMode);
  useEffect(() => {
    const onChange = (e) => setLocal(e.detail);
    window.addEventListener('blade-theme-change', onChange);
    return () => window.removeEventListener('blade-theme-change', onChange);
  }, []);
  return { mode, cycle: () => setMode(nextMode(mode)) };
}
